export default Object.freeze({
  WORKFLOW_LIST: '/',
  SETTINGS: '/settings',
  HELP: '/help',
});
